import { render, staticRenderFns } from "./UserLabelTypeBlock.vue?vue&type=template&id=65200415&scoped=true"
import script from "./UserLabelTypeBlock.vue?vue&type=script&lang=js"
export * from "./UserLabelTypeBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65200415",
  null
  
)

export default component.exports